export default "__VITE_ASSET__o7C_QY5X__"